import { render } from "./Blogs.vue?vue&type=template&id=4f31b6d0"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"

import "./Blogs.vue?vue&type=style&index=0&id=4f31b6d0&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__